import { useUnassignOrderModal } from '@/components/modals/UnassignOrderModal'

import { useTexts } from '../useTexts'
import { useCanUnassign } from './useCanUnassign'

export function useUnassignButtonData(extOrder: uui.domain.client.rm.ExtendedOrderStep) {
  const { show: showUnassignOrderModal, Modal: UnassignOrderModal } = useUnassignOrderModal()
  const canUnassign = useCanUnassign(extOrder)
  const texts = useTexts()

  const unassignOrderDisabled = !canUnassign
  const unassignOrderTooltip = unassignOrderDisabled
    ? texts.canUnassignTooltipTitle
    : texts.unassignOrder

  return {
    unassignOrderDisabled,
    unassignOrderTooltip,
    UnassignOrderModal,
    unassignOrder: showUnassignOrderModal,
  }
}
